import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
//UI
import HeadDetail from "../../../../components/headDetail";
import { Form, Message } from "semantic-ui-react";
import Divider from "@material-ui/core/Divider";
import "../../../styles/common.css";
import "semantic-ui-css/semantic.min.css";
//ACTIONS
import { createReservation } from "../../../../redux/actions/reservations/reservation/createReservation";
import { initialStateReservation } from "../../../../redux/actions/reservations/reservation/fetchReservation";
import { updateReservation } from "../../../../redux/actions/reservations/reservation/updateReservation";
import { findContractRateByCruiseAgencyContractType } from "../../../../redux/actions/rates/contractRates/findContractRateByCruiseAgencyCruiseType";
import { findIkarusRateByCruiseAgencyContractType } from "../../../../redux/actions/rates/ikarusRates/findIkarusRateByCruiseAgencyCruiseType";
import { fetchReservationFormCustom, initialStateReservationFormCustom } from "../../../../redux/slices/custom/reservations/cruise/reservation/customReservationForm.slice";
//Components
import ContractCheckBox from "../../../../components/reservation/contractCheckBox"
import IkarusRateCheckBox from "../../../../components/reservation/ikarusRateCheckBox"

import { scrollToTop } from "../../../resources/utils";
import { reservationStatus, cruiseTypes, salesReport, } from "../../../resources/optionsList";
import { CircularProgress } from "@material-ui/core";

export default function ReservationForm() {

  const dispatch = useDispatch();
  let history = useHistory();
  let { cruise_id } = useParams();
  let { reservation_id } = useParams();
  const { t } = useTranslation();
  const { setValue, register, handleSubmit, errors, getValues } = useForm();

  const reservationStateCustom = useSelector((state) => state.customReservationForm);
  const reservationState = useSelector((state) => state.reservationReducer);

  const [contractChecked, setContractChecked] = useState(false);
  const [ikarusChecked, setIkarusChecked] = useState(false);
  const [charterChecked, setCharterChecked] = useState(false);
  const [disabledTimeLimit, setDisabledTimeLimit] = useState(true);

  useEffect(() => {
    dispatch(fetchReservationFormCustom("", cruise_id, reservation_id))
    scrollToTop();
    return (() => {
      dispatch(initialStateReservationFormCustom());
      dispatch(initialStateReservation());
    })
  }, []);

  useEffect(() => {
    if (reservation_id) {
      setValue("agency_id", reservationStateCustom.reservation.agency_id);
      setValue("cruise_type", reservationStateCustom.reservation.cruise_type);
      setValue("notes", reservationStateCustom.reservation.notes);
      setValue("include_flight_ticket", reservationState.reservation?.include_flight_ticket || reservationStateCustom.reservation.include_flight_ticket);
      setValue("charter_state", reservationStateCustom.reservation.charter_state);
      setValue("charter_time_limit", reservationStateCustom.reservation.charter_time_limit);
      setValue("salesReport120Days", reservationStateCustom.reservation.salesReport120Days);
      setValue("salesReport90Days", reservationStateCustom.reservation.salesReport90Days);
      setValue("salesReport60Days", reservationStateCustom.reservation.salesReport60Days);
      setIkarusChecked(reservationStateCustom.reservation.ikarus_rate);
      setContractChecked(reservationStateCustom.reservation.contract_rate);
      setCharterChecked(reservationStateCustom.reservation.charter);
      setDisabledTimeLimit(reservationStateCustom.reservation.charter_state === "reserved" ? false : true);
    }
  }, [setValue, reservationStateCustom.reservation]);


  if (reservationStateCustom.fetching || reservationState.fetching) {
    return <CircularProgress />;
  }

  const handleFindContractRate = () => {
    const data = {
      agency_id: getValues("agency_id"),
      cruise_type: getValues("cruise_type")
    };
    dispatch(findContractRateByCruiseAgencyContractType(cruise_id, data));
    dispatch(findIkarusRateByCruiseAgencyContractType(cruise_id, data));
  };

  const handleContractChange = (isChecked) => {
    setContractChecked(isChecked);
    if (isChecked) {
      setValue("include_flight_ticket", '');
    }
  };

  const handleIkarusRateChange = (isChecked) => {
    setIkarusChecked(isChecked);
    if (isChecked) {
      setValue("include_flight_ticket", '');
    }
  };

  const handleCharterChange = (e) => {
    const isChecked = e.target.checked;
    setCharterChecked(isChecked);

    if (!isChecked) {
      setDisabledTimeLimit(true);
      setValue("charter_state", '');
      setValue("charter_time_limit", '');
      setValue("include_flight_ticket", '');
    } else {
      setValue("charter_state", reservationStateCustom.reservation.charter_state);
      setValue("charter_time_limit", reservationStateCustom.reservation.charter_time_limit);
      setValue("include_flight_ticket", reservationState.reservation?.include_flight_ticket || reservationStateCustom.reservation.include_flight_ticket);
    }
  };

  function calculateTimeLimitDays() {
    var currentDate = new Date();
    var startCruiseDateArray = reservationStateCustom.cruise.start_date_format.split("/");
    var startCruiseDate = new Date(startCruiseDateArray[1] + "/" + startCruiseDateArray[0] + "/" + startCruiseDateArray[2]);
    var differenceInTime = startCruiseDate.getTime() - currentDate.getTime();
    var differenceInDays = differenceInTime / (1000 * 3600 * 24);
    if (differenceInDays < 60) {
      return 3;
    }
    return 7;
  }

  const handleDisableTimeLimit = (state) => {
    if (state === "reserved") {
      setDisabledTimeLimit(false);
      var currentDate = new Date();
      var timeLimitDate = new Date(currentDate.setDate(currentDate.getDate() + calculateTimeLimitDays()));
      var options = { year: "numeric", month: "2-digit", day: "2-digit" };
      setValue("charter_time_limit", timeLimitDate.toLocaleDateString("es", options).split("/").reverse().join("-"));
    } else {
      setDisabledTimeLimit(true);
      setValue("charter_time_limit", '');
    }
  };

  const submit = (data) => {
    if (reservation_id) {
      data["cruise_id"] = cruise_id;
      dispatch(updateReservation(reservation_id, data));
    } else {
      dispatch(createReservation(cruise_id, data));
    }
  };

  if (reservationState.message === "resource created successfully" || reservationState.message === "resource updated successfully") {
    history.go(-1);
  }

  return (
    < div className="flex flex-col space-y-8">
      {reservationState.error ? (<Message negative content={t(reservationState.error)} />) : " "}
      <div className="ui breadcrumb">
        <Link to={`/cruises/${cruise_id}/cruise-detail`}>
          <div className="active section">{reservationStateCustom.cruise.code}</div>
        </Link>
        <div className="divider">/</div>
        <Link to={`/cruises/${cruise_id}/reservations`}>
          <div className="active section">{t("reservation_title")} </div>
        </Link>
        <div className="divider">/</div>
        <div className="active section">{t("reservation_path")} </div>
      </div>
      <HeadDetail
        yacht_name={reservationStateCustom.cruise.yacht_name}
        itinerary_name={reservationStateCustom.cruise.itinerary_name}
        start_date={reservationStateCustom.cruise.start_date_format}
        end_date={reservationStateCustom.cruise.end_date_format}
      />
      <Form onSubmit={handleSubmit(submit)} >
        <div className='flex flex-col gap-5'>
          <label>{t("general_information_tag")}
            <Divider variant="fullWidth" />
          </label>
          <Form.Group widths="equal">
            <Form.Field required>
              <label>{t("reservation_agency")}</label>
              <select
                aria-expanded="true"
                name="agency_id"
                onChange={handleFindContractRate}
                ref={register({ required: true })}
              >
                <option></option>
                {reservationStateCustom.agencies.map((agency) => (
                  <option className="selected item" key={agency.id} value={agency.id}>
                    {agency.name}
                  </option>
                ))}
              </select>
              {errors.agency_id && (<span className="error_message">{t("required_information")}{" "}</span>)}
            </Form.Field>
            <Form.Field required>
              <label>{t("reservation_type")}</label>
              {
              reservationStateCustom.checkItineraryDivision === "itinerary divided" ? (
                <select
                  aria-expanded="true"
                  name="cruise_type"
                  defaultValue={reservationStateCustom.reservation.cruise_type}
                  onChange={handleFindContractRate}
                  ref={register({ required: true })}
                >
                  <option></option>
                  {cruiseTypes.map((cruiseType, index) => (
                    <option className="selected item" key={index} value={cruiseType.value} >
                      {t(cruiseType.name)}
                    </option>
                  ))}
                </select>) 
              : 
              reservationStateCustom.checkItineraryDivision === "itinerary not divided" ? (
                  <select
                    aria-expanded="true"
                    name="cruise_type"
                    defaultValue={reservationStateCustom.reservation.cruise_type}
                    onChange={handleFindContractRate}
                    ref={register({ required: true })}
                  >
                    <option></option>
                    <option className="selected item" value={cruiseTypes[2].value} >
                      {cruiseTypes[2].value}
                    </option>
                  </select>
                ) : (
                ""
              )}
              {errors.cruise_type && (<span className="error_message"> {t("required_information")}{" "} </span>
              )}
            </Form.Field>
            <Form.Field>
              <ContractCheckBox
                cruise_id={reservationStateCustom.reservation.cruise_id}
                cruise_type={reservationStateCustom.reservation.cruise_type}
                agency_id={reservationStateCustom.reservation.agency_id}
                contract_rate={contractChecked}
                register={register}
                handleContractChange={handleContractChange}
              />
              <IkarusRateCheckBox cruise_id={reservationStateCustom.reservation.cruise_id}
                cruise_type={reservationStateCustom.reservation.cruise_type}
                agency_id={reservationStateCustom.reservation.agency_id}
                ikarus_rate={ikarusChecked}
                register={register}
                handleIkarusRateChange={handleIkarusRateChange}
              />
            </Form.Field>
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Field>
              <label>{t("reservation_notes")} </label>
              <textarea
                rows={3}
                placeholder={t("reservation_notes")}
                name="notes"
                ref={register}
                defaultValue={reservationStateCustom.reservation.notes}
              ></textarea>
            </Form.Field>
          </Form.Group>
          <label>{t("reservation_charter_tag")}
            <Divider variant="fullWidth" />
          </label>
          <Form.Group widths="equal">
            <Form.Field width={4}>
              <label>{t("reservation_charter")}</label>
              <div className="ui checkbox">
                <input
                  type="checkbox"
                  name="charter"
                  checked={charterChecked}
                  ref={register}
                  onChange={handleCharterChange}
                />
                <label></label>
              </div>
            </Form.Field>
            <Form.Field width={6}>
              <label>{t("space_ratePriceInclude")}</label>
              <div className="ui checkbox">
                <input
                  disabled={(contractChecked || ikarusChecked) ? true : false}
                  type="checkbox"
                  name="include_flight_ticket"
                  ref={register}
                />
                <label></label>
              </div>
            </Form.Field>
            <Form.Field width={6} required={charterChecked ? true : false} >
              <label>{t("reservation_charterState")} </label>
              <select id="charterState"
                aria-expanded="true"
                name="charter_state"
                disabled={reservationStateCustom.reservation.charter_state === "confirmed" ? true : charterChecked ? false : true}
                ref={register(charterChecked ? { required: true } : { required: false })}
                onChange={(e) => handleDisableTimeLimit(e.target.value)}
              >
                <option></option>
                {reservationStatus.map((reserveState, index) => (
                  <option className="selected item" key={index} value={reserveState.value}>
                    {t(reserveState.name)}
                  </option>
                ))}
                {errors.charter_state && (<span className="error_message">{t("required_information")}{" "}</span>)}
              </select>
            </Form.Field>
            <Form.Field required={disabledTimeLimit ? false : true}>
              <label> {t("reservation_timeLimit")}</label>
              <input
                id="charterTimeLimit"
                disabled={disabledTimeLimit}
                type="date"
                name="charter_time_limit"
                ref={register(disabledTimeLimit ? { required: false } : { required: true })}
              />
              {errors.charter_time_limit && (<span className="error_message">{t("required_information")}{" "}</span>)}
            </Form.Field>
          </Form.Group>
          <label>{t("reservation_salesReport")}
            <Divider variant="fullWidth" />
          </label>
          <Form.Group widths="equal">
            <Form.Field>
              <label>120 {t("reservation_days")} </label>
              <select
                aria-expanded="true"
                name="salesReport120Days"
                ref={register}
              >
                <option></option>
                {salesReport.map((day, index) => (
                  <option className="selected item" key={index} value={day}>
                    {day}
                  </option>
                ))}
              </select>
            </Form.Field>
            <Form.Field>
              <label>90 {t("reservation_days")}</label>
              <select
                aria-expanded="true"
                name="salesReport90Days"
                ref={register}
              >
                <option></option>
                {salesReport.map((day, index) => (
                  <option className="selected item" key={index} value={day}>
                    {day}
                  </option>
                ))}
              </select>
            </Form.Field>
            <Form.Field>
              <label>60 {t("reservation_days")}</label>
              <select
                aria-expanded="true"
                name="salesReport60Days"
                ref={register}
              >
                <option></option>
                {salesReport.map((day, index) => (
                  <option className="selected item" key={index} value={day}>
                    {day}
                  </option>
                ))}
              </select>
            </Form.Field>
          </Form.Group>
          <Divider variant="middle" />
          <div className="flex">
            <Link to={`/cruises/${cruise_id}/reservations`}>
              <button type="button" className="ui button">
                {t("canceled_button")}
              </button>
            </Link>
            <button className={reservationState.processing ? "ui loading primary button" : "ui primary button"}>
              {t("save_button")}
            </button>
          </div>
        </div>
      </Form>
    </div>
  );
}
